import { useMemo } from 'react';
import { parseDomain } from '@wix/domains-serverless-interface';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
const TOTAL_BULLETS = 3;
const DEFAULT_TOTAL_ROWS = 2;
const pickTwoRandomIndices = () => {
  const first = Math.floor(Math.random() * TOTAL_BULLETS);
  const offset = 1 + Math.floor(Math.random() * (TOTAL_BULLETS - 1));
  const second = (first + offset) % TOTAL_BULLETS;
  return [first, second];
};
export const useHeroInsightBullets = function (domain, _temp) {
  let {
    totalRows = DEFAULT_TOTAL_ROWS
  } = _temp === void 0 ? {} : _temp;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return useMemo(() => {
    const tld = parseDomain(domain).tld;
    const allBullets = Array.from({
      length: TOTAL_BULLETS
    }, (_, index) => {
      const tldKey = `domain_search_gate.insight_widget.fallback_insight.${tld}.insight_${index + 1}`;
      const tldValue = t(tldKey);
      if (tldValue !== tldKey) {
        return tldValue;
      }
      return t(`domain_search_gate.insight_widget.fallback_insight.generic.insight_${index + 1}`);
    });
    const [a, b] = pickTwoRandomIndices();
    return [allBullets[a], allBullets[b]].slice(0, totalRows);
  }, [domain, t, totalRows]);
};
//# sourceMappingURL=useHeroInsightBullets.js.map